import { Badge, Box, Group, Tooltip } from '@mantine/core';
import { Radio } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useAbly } from '../providers/AblyProvider';

export function VrSessionChannelStatus() {
  const { t } = useTranslation();
  const { connectionStatus } = useAbly();

  const isOnline = connectionStatus === 'connected';
  const isConnecting = connectionStatus === 'connecting';

  const statusLabel = isOnline
    ? t('header_vr_channel_online', 'Online')
    : isConnecting
      ? t('header_vr_channel_connecting', 'Connecting')
      : t('header_vr_channel_offline', 'Offline');

  const statusColor = isOnline ? 'teal' : isConnecting ? 'yellow' : 'red';
  const iconColor = isOnline
    ? 'var(--mantine-color-teal-6)'
    : isConnecting
      ? 'var(--mantine-color-yellow-6)'
      : 'var(--mantine-color-red-6)';

  return (
    <Tooltip
      label={t(
        'header_vr_channel_tooltip',
        'Canale di comunicazione in tempo reale con gli eventi delle sessioni in realtà virtuale.'
      )}
      multiline
      w={280}
      withArrow
    >
      <Group gap={6} wrap='nowrap' style={{ cursor: 'default' }}>
        <Radio size={16} style={{ color: iconColor }} aria-hidden />
        <Box visibleFrom='sm'>
          <Badge size='sm' variant='light' color={statusColor}>
            {statusLabel}
          </Badge>
        </Box>
      </Group>
    </Tooltip>
  );
}
